/**
 * Parse `<script id="env">...</script>` from the current `document`,
 * which is provided by {@link ../../../../views/index.blade.php}
 *
 * The values of the variables are configured via the backend. (.env, etc.)
 *
 * Assign types, validate and export all values.
 *
 * @module
 */

import {parseScriptElementAsJson} from '@acng/frontend-bounty/parse';
import {configure} from 'nova';
import {ENV, guard} from '../../model';

/**
 * @import {ServiceWorkerConfig} from 'nova'; 
 * @import {ObrienConfig} from '../../api/obrien-client.js';
 */

const ENV_ID = 'env';

/**
 * @deprecated DO NOT USE THIS EXPORT
 */
export const env = parseScriptElementAsJson(ENV_ID);
ASSERT: guard(env, ENV, 'ENV');

/**
 * @typedef GlobalConfig
 *
 * @property {boolean} [DEBUG] Print configured object to the console.
 * @property {ServiceWorkerConfig} serviceWorker
 * @property {ObrienConfig} obrien
 */

/**
 * @type {GlobalConfig}
 */
export const appConfig = {
  // DEBUG: true,
  serviceWorker: {src: env.SWFile},
  obrien: {baseURL: env.OBRIEN},
};

/**
 * Get a singleton instance for the given constructor.
 */
export const make = configure(appConfig);

/**
 * Contains base paths for assets and content.
 * TODO explain and cleanup
 */
export const media = env.media;

/**
 * @param {string} src
 */
export const asset = (src) => `${media.assets}/${src}`;

export const FEATURES = env.FEATURES;

/**
 * @param {string} name
 * @returns {boolean} -
 */
export const hasFeature = (name) => FEATURES.includes(name);

/**
 * TODO explain
 */
export const INHERIT = env.INHERIT;

export const freeCoinsConfig = env.freeCoinsConfig;
export const hasMyPortal = env.hasMyPortal;
export const startUpCountry = env.startUpCountry;
export const startUpLanguage = env.startUpLanguage;
export const startUpFsk = env.startUpFsk;
export const VERSION = env.VERSION;
export const API_cdn = env.API_cdn;
export const isMobile = env.isMobile;
export const SONUS = env.SONUS;
export const UTM = env.UTM;
export const PLAYPAL_STATIC = env.PLAYPAL_STATIC;
export const ARCHIMEDES = env.ARCHIMEDES;
export const dummyImageMap = env.dummyImageMap;
export const OBRIEN = env.OBRIEN;
export const RATATOSKR = env.RATATOSKR;

/**
 * The event bus master **SockJS** URL
 */
export const TROI = env.TROI;

/**
 * @property fsk Blka
 */
export const authUser = env.authUser;
export const BUILD = env.BUILD;
export const laForge = env.LaForge;
